import { useEffect, useState } from 'react';

const SPINS = 3;
const STRIP = Array.from({ length: (SPINS + 1) * 10 }, (_, i) => i % 10);

export default function AnimatedNumber({
  value,
  duration = 1400,
  delay = 0,
  className = '',
}) {
  const [rolled, setRolled] = useState(false);

  useEffect(() => {
    let raf2 = 0;
    const raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => setRolled(true));
    });
    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
    };
  }, [value]);

  const chars = value.split('');
  let digitIndex = -1;

  return (
    <span className={`odo ${className}`} aria-label={value}>
      {chars.map((ch, i) => {
        if (!/\d/.test(ch)) {
          return (
            <span key={i} className="odo-static">
              {ch}
            </span>
          );
        }

        digitIndex += 1;
        const target = parseInt(ch, 10);
        const stopAt = SPINS * 10 + target;

        const colDuration = duration + digitIndex * 130;

        return (
          <span key={i} className="odo-col">
            <span
              className="odo-strip"
              style={{
                transform: rolled ? `translateY(-${stopAt}em)` : 'translateY(0em)',
                transitionDuration: `${colDuration}ms`,
                transitionDelay: `${delay}ms`,
              }}
            >
              {STRIP.map((n, k) => (
                <span key={k} className="odo-digit">
                  {n}
                </span>
              ))}
            </span>
          </span>
        );
      })}
    </span>
  );
}
